export default {
  methods: {
    validateEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },

    userHasType(type) {
      if (!this.$page.props.auth.user || !this.$page.props.auth.user.type) {
        return false;
      }

      return this.$page.props.auth.user.type === type;
    },

    userHasRole(role) {
      if (!this.$page.props.auth.user || !this.$page.props.auth.user.roles) {
        return false;
      }

      let {
        roles,
      } = this.$page.props.auth.user;

      roles = roles.filter((r) => r.toLowerCase() === role);
      return roles.length > 0;
    },

    userHasPermissionTo(permission) {
      if (!this.$page.props.auth.user || !this.$page.props.auth.user.permissions) {
        return false;
      }

      let {
        permissions,
      } = this.$page.props.auth.user;

      permissions = permissions.filter((r) => r.toLowerCase() === permission);
      return permissions.length > 0;
    },

    userMatches(id) {
      if (!this.$page.props.auth.user) {
        return false;
      }

      return this.$page.props.auth.user.id === id;
    },
  },
};
